"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getControlByPath = ({ control, path }) => {
    if (path.length === 0) {
        return control;
    }
    const actualPath = path.reduce((accum, pathIndex) => ([
        ...accum,
        'controls',
        pathIndex,
    ]), []);
    return (0, getValueByPathFromUnknown_1.default)(control, actualPath);
};
exports.default = getControlByPath;
